export default "__VITE_ASSET__BUseVui5__"